// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"c7ecc522","43":"874b487b","573":"9322d84c","595":"55cf041d","736":"d892412b","787":"7c356224","905":"0b3568a4"}[chunkId] + ".chunk.js";
};